import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";
import EntityName from "data/util/EntityName";

const MappingActions = {
    MODEL_LOADED: typedAction("mapping/model-loaded", {
        targetKey: EntityName.propType.isRequired,
        sourceKey: EntityName.propType.isRequired,
    }),
    MODEL_LOAD_ERROR: typedAction("mapping/model-load-error", {
        targetKey: EntityName.propType.isRequired,
        sourceKey: EntityName.propType.isRequired,
    }),

    // An order-of-operations cycle is present, so need to... do it again.
    // This also implies that we're not waiting for an async operation to
    // resolve, as that'll reexecute the workflow on it's own.
    __DO_IT_AGAIN: typedAction("mapping/--do-it-again", {
        reason: PropTypes.string.isRequired,
    }),

    __PROCESS_NEXT_IN_QUEUE: "mapping/--process-next-in-queue",

    // Time to commit and clean up.
    IT_IS_DONE: typedAction("mapping/it-is-done", {
        trigger: PropTypes.string.isRequired,
        initiatingContext: PropTypes.string,
    }),
};

export default MappingActions;



// WEBPACK FOOTER //
// ./app/data/MappingActions.js